import React, {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import {
    BubbleMenu,
    EditorContent,
    EditorProvider, isMacOS, mergeAttributes,
    ReactNodeViewRenderer,
    useCurrentEditor,
    useEditor
} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Export} from "@tiptap-pro/extension-export";
import RenderCustomTable from "../../../../../src/components/EditorV2/Table/RenderCustomTable";
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import CustomTableCell from "../../../../../src/components/EditorV2/TableCell/tableCell";
import {UniqueID} from "@tiptap-pro/extension-unique-id";
import Focus from "@tiptap/extension-focus";
import Gapcursor from "@tiptap/extension-gapcursor";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {Color} from "@tiptap/extension-color";
import { rotate } from "../../math";
import { getHoverHandles } from "../../element/resizeTest";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import {getBlockMenu} from "../../../../../src/components/EditorV2/BlockMenu/BlockMenu";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "../../../../../src/components/EditorV2/indent";
import ImageT from "@tiptap/extension-image";
import Image from "../../../../../src/components/EditorV2/imgResize";
import SearchNReplace from "../../../../../src/components/EditorV2/Search/plugin";
import {fileToBase64, ImagePaste} from "../../../../../src/components/EditorV2/ImagePaste";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "../../../../../src/components/EditorV2/task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import CodeBlockComponent from "../../../../../src/components/EditorV2/CodeBlock3";
import {lowlight} from "lowlight";
import DeeplinkNode from "../../../../../src/components/Deeplink/DeeplinkNode";
import CodeInlie from '@tiptap/extension-code'
import {Extension, markPasteRule, NodePos,findParentNode, InputRule} from '@tiptap/core'
import {
    calcCardTitleHeight,
    calcTextAreaHeight,
    createCopyLink,
    decodeDeeplink, extFromMineType,
    firstLetterUpper, generateUUID2,
    getImagePathWithTheme, getIntValue, getYouTubeThumbnailUrl,
    imgPathPerfix, isDarkMode,
    isDeepLink, isDefaultBackgroundColor, isStringNullOrEmpty, migrateInlineCodeToOfficial, removeHtmlTags,
    replaceLatexInParagraph, sleep
} from "../../../../../src/utils";
import {
    CARD_MAX_PASTE_SIZE,
    DEFAULT_COLLAPSE_HEIGHT,
    DEFAULT_COLLAPSE_HEIGHT_1,
    DEFAULT_TOOLBAR_HEIGHT, ELEMENT_POPOVER_TOOLS_OFFSET_Y,
    EVENT_ACTIVE_CARD_EDIT,
    EVENT_CANVAS_EXPAND_STATS_CHANGED,
    EVENT_CANVAS_SELECTION_CHANGED,
    EVENT_CLOSE_IMAGE_ACTION,
    EVENT_COPY_DOC_NOTE,
    EVENT_DELETE_HTML_NOTE,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_REFRESH_EDIT_CARD,
    EVENT_REFRESH_LIBRARY_LIST, EVENT_REFRESH_RECENTS, EVENT_REFRESH_SLIDER_INFO, EVENT_RENAME_LIBRARY_ITEM,
    EVENT_RESIZING_CARD,
    EVENT_SHOW_CONTEXT_MENU,
    EVENT_SYNC_NOTE_DATA, EVENT_SYNC_REFRESH_DRAW_CARDEDIT, EVENT_TEST_ONDRAG_NOTE,
    EVENT_UPDATE_CANVAS_NOTE_TO_DB,
    EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
    EVENT_UPDATE_NOTE,
    EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,
    EVENT_UPDATE_NOTE_HEIGHT, getElementSelectionBorderColor, getNoteElementBackgroundColor,
    LINK_INFO_TYPE_LIBRARY,
    LINK_INFO_TYPE_PROJECT,
    MAP_WEEK,
    MAP_WEEK_FULL,
    MARGIN_TOP_CONTENT, MAX_AUTO_CARD_EDIT_HEIGHT, MAX_IMAGE_FILE_SIZE,
    MAX_SIZE, MAX_Z_INDEX,
    MENU_SEPARATOR
} from "../../../../../src/Const";
import {batchCardHighlight, getCardById, getNoteById, removeCardImage, updateCard} from "../../../../../model";
import {
    createDeeplinkView,
    getCardBlock,
    getCardPath,
    getCardTitle,
    getImageNameFromdeepLinkType, insertCopyLinkToCard, insertDeeplinkToCard
} from "../../../../../src/Utility";
import {imgServer} from "../../../../../src/components/EditorV2/imgServer";
import {postMessage, recvMessage, unSubscribe} from "../../../../../src/common/event";
// import './CardEdit.css'
import style from "./CardEdit.module.less";
import {Dropdown, message, Popover, Tooltip} from "antd";
import i18n, {t} from "i18next";
import ColorPickers from "../../../../../src/components/EditorV2/ColorPicker";
import {KEYS} from "../../keys";
import Link from "../../../../../src/components/EditorV2/extension-link/src/index"

import {closeEditor, FullScreen, openEditor} from "../../../../../src/state";
import global from "../../../../../src/global";
import {useTranslation} from "react-i18next";
import ImgAction from "../../../../../src/components/EditorV2/ImgAction";
import {APP_WEB} from "../../../../../src/electron_interactive";
import Background from 'tiptap-extension-background-color'
// import Youtube from "@tiptap/extension-youtube";
import Youtube from "../../../../../src/components/EditorV2/extension-youtube";
import HardBreak from "@tiptap/extension-hard-break";
import Mathematics from "@tiptap-pro/extension-mathematics";
import latexBlock from "../../../../../src/components/EditorV2/latexMath/latexBlock";
import 'katex/dist/katex.min.css'
import clipboard from "clipboardy";
import {sceneCoordsToViewportCoords, viewportCoordsToSceneCoords} from "../../utils";
import * as model from '@model'
import img from "../../../../../src/components/EditorV2/imgs/colorPicker.png";
import {useAtom} from "jotai";
import {randomInteger} from "../../random";
import {mutateElement} from "../../element/mutateElement";
import ListKeymap from '@tiptap/extension-list-keymap'
import {PopupCardPlus} from "../../../../../src/components/Plus/PopupCardPlus";
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import BulletList from '@tiptap/extension-bullet-list'
import HighlightPicker from "../../../../../src/components/EditorV2/HighlightPicker/HighlightPicker";
import TurnNewCard from "../../../../../src/components/EditorV2/TurnNewCard/TurnNewCard";
import {
    handleBackspace,
    handleClipboard, handlePaste, handleShiftTab, handleTab,
    handleTransformPastedHTML,
    handleTransformPastedText
} from "../../../../../src/components/EditorV2/TiptapCommonHandle";
import latexInline from "../../../../../src/components/EditorV2/latexInline/latexInline";
import {getHeadingExtend} from "../../../../../src/components/EditorV2/EditorExtensions/HeadingExtend";
import {getListItemExtend} from "../../../../../src/components/EditorV2/EditorExtensions/ListItemExtend";
import {debugLog} from "../../../../../src/LogUtils";
import {getBubblletListExtend} from "../../../../../src/components/EditorV2/EditorExtensions/BulletListExtend";
import {ipcInvoke} from "../../../../../src/common/ipc";
import {
    getHyperlinkExtension,
    getOperatorAlignExtension, getOperatorOnSpaceOrEnter
} from "../../../../../src/components/EditorV2/TiptapTiptapExtension";
import GlobalDragHandle from "../../../../../src/components/EditorV2/drag";
import { Plugin,PluginKey,NodeSelection, TextSelection } from 'prosemirror-state';
import { Decoration, DecorationSet } from "@tiptap/pm/view"


let timer:any = null

let mIsEditStatsUpdate:any = false;

//浮动菜单的最小宽度
const BUBBLUE_MENU_MIN_WIDTH = 360;

const HEIGHT_OFFSET = 0;
let TITLE_MARGIN_TOP = 0;
const CARD_EDIT_DRAG_ID_PRE = "card-edit-drag-handle-";

const mapDivScroll:any = {};

const MAX_CARD_HEIGHT = 800;

const CardEdit = forwardRef((props:{app:any,state:any,data:any,element:any,updateElementCallback:any,onActionCallback:any,onMouseDown:any,onMouseMove:any,onMouseUp:any,onWheel:any,onTextSelection:any,isRender:any,isSelected?:any}, ref) => {
    const [pos, setPos] = useState<[boolean, number]>([false, 0]);
    const [isEditable, setIsEditable] = useState(false);
    const [isTitleHoverd, setIsTitleHoverd] = useState(false);
    const [imgRotate, setImgRotate] = useState('rotate(0deg)');
    const divTitleRef = useRef(null);
    const txtTitleRef = useRef(null);
    const divContainerRef = useRef(null);
    const [isEnableEvents, setIsEnableEvents] = useState(true);
    const [cardTitle, setCardTitle] = useState(props.element.customData.generationData.name);
    const [isExpand,setIsExpand] = useState(props.element.customData.generationData.isExpand);
    const [isHiddenInLibrary,setIsHiddenInLibrary] = useState(false);

    const [isShowTextBar, setIsShowTextBar] = useState(true);
    const [hasTitle,setHasTitle] = useState(true);

    const cardTitleRefRefRefRefRefRef = useRef('');

    const mIsMouseDown = useRef(false);
    const mIsMoving = useRef(false);
    const mOffset = useRef({x:0,y:0});//偏移
    const [isShowDoubleTitleTip,setIsShowDoubleTitleTip] = useState(false);
    const [arrayTags,setArrayTags] = useState([]);

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    /**
     * 第一次获取焦点
     */
    const isFirstFocus = useRef(true);

    const [cardFullScreen, setCardFullScreen] = useAtom(FullScreen)

    let mEditor = useRef<any>(null);

    let selectedDragNode: any;

    const importConfig = global.g_edit_md_token;
    const extensions = [
        StarterKit,
        // 运算符垂直对齐：通过 Decoration 给 + - * / 包裹 span，配合 editor.less 中的 CSS 变量控制偏移
        getOperatorAlignExtension(),
        getOperatorOnSpaceOrEnter(),
        // InlineCodeMark,
        CodeInlie,
        getListItemExtend('cardEdit'),
        OrderedList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        getBubblletListExtend(),
        Youtube.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    highlightImgUrl: {
                        default: '',
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        Export.configure(importConfig),
        Focus.configure({
            className: 'has-focus',
            mode: 'deepest',
        }),
        RenderCustomTable.configure({
            resizable: true,
            // allowTableNodeSelection: true,
        }),
        TableRow,
        TableHeader,
        CustomTableCell,
        ListKeymap,
        HardBreak.extend({
            addKeyboardShortcuts() {
                return {
                    "Mod-e":()=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-k":()=>{
                        if (editor.state.selection.from != editor.state.selection.to){
                            showLink();
                        }else{
                            //显示全局的搜索.
                            window.showDialogGlobalSearch();
                        }
                    },
                    "Mod-Shift-e":()=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },
                    "Mod-E":()=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-K":()=>{
                        showLink();
                    },
                    "Mod-Shift-E":()=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },

                    Enter: () => {
                        // const divCustomDrag = document.querySelector(".custom-drag-handle");
                        // if (divCustomDrag) {
                        //     divCustomDrag.style.display = "none";
                        // }
                        const { from, to } = mEditor.current?.state.selection;
                        const resolvedPos = mEditor.current?.state.doc.resolve(from);
                        // 获取当前节点
                        const currentNode = resolvedPos.node();
                        if (resolvedPos.parentOffset === 0 && currentNode.type.name === 'paragraph') {
                            setTimeout(() => {
                                const { from, to } = mEditor.current?.state.selection;
                                const resolvedPos = mEditor.current?.state.doc.resolve(from);
                                // 获取下一个节点
                                const node = resolvedPos.node();
                                let tempID = node.attrs.id
                                node.attrs.id = currentNode.attrs.id
                                currentNode.attrs.id = tempID
                                console.log('---77');

                            }, 100);
                        }
                        return false;
                    },
                    Backspace: () => {
                        const { from, to } = mEditor.current.state.selection;
                        if (mEditor.current.isEmpty || (from == to && from <= 1)){
                            //标题获取焦点
                            if (hasTitle){
                                txtTitleRef.current?.focus();
                                // return true;
                            }
                        }

                        return handleBackspace(mEditor.current,txtTitleRef);
                    },
                    Tab: () => {
                        return handleTab(mEditor.current);
                    },
                    'Shift-Tab': () => {
                        return handleShiftTab(mEditor.current);
                    }
                }
            }
        }),
        // Mathematics.configure({
        //     // regex: /\&\&([^\&]*)\&\&/gi
        // }),
        latexInline,
        latexBlock,
        UniqueID.configure({
            types: ['tableRow', 'taskList', 'paragraph','deeplink', 'image', 'blockquote', 'bulletList', 'orderedList', 'horizontalRule', 'youtube', 'table', 'highlight', 'latexBlock'],
            filterTransaction: transaction => {
                return !transaction.getMeta('preventUpdate')
            }
        }),
        Gapcursor,
        Focus.configure({
            className: 'has-focus',
            mode: 'deepest',
        }),
        Text,
        TextStyle,
        Color,
        getHeadingExtend(),
        Paragraph.extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        Highlight.configure({ multicolor: true }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    id: {
                        default: crypto.randomUUID()
                    },
                    noteText: {
                        default: '',
                    },
                };
            },
            addCommands() {
                return {
                    ...this.parent?.(),
                    setHighlightId: (id,from) =>async  ({ tr, state, dispatch }) => {
                        await sleep(30)
                        const resolvedPos = this.editor.state.doc.resolve(from);
                        // 获取当前节点  实际id已经改变了，只是渲染的id值没变 重新渲染即可
                        const currentNode = resolvedPos.node().content.content[0];
                        currentNode.marks[0].attrs={...currentNode.marks[0].attrs,id:id}
                        return true;
                    }
                };
            }
        }),
        TextAlign.configure({
            types: ["heading", "paragraph"],
        }).extend({
            addKeyboardShortcuts() {
                return{
                    "Mod-Shift-e":()=>{
                        return false;
                    },
                    "Mod-Shift-E":()=>{
                        return false;
                    },
                }
            }
        }),
        Underline,
        getBlockMenu(),
        PopupCardPlus,
        Placeholder.configure({
            placeholder: '',
        }),
        FontSize,
        Indent,
        Link.configure({
            protocols: ['noteey', 'noteeditor'],
            autolink: false,
            linkOnPaste: false,
        }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                }
            }
        }),
        ImageT,
        Background,
        Image.configure({
            allowBase64: true,
            fromCardEdit:true
        }),
        SearchNReplace.configure({
            searchResultClass: "search-result", // class to give to found items. default 'search-result'
            caseSensitive: false, // no need to explain
            disableRegex: false, // also no need to explain
        }),
        ImagePaste.configure({
            fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
            disableImagePaste: false,
            render: () => {
                return {
                    onImagePaste: files => {
                        files.forEach(file => {
                            if (file.size > MAX_IMAGE_FILE_SIZE){
                                const id = crypto.randomUUID();
                                const szFileName = id +'.' + extFromMineType(file.type);
                                ipcInvoke('resize-image-file',{filePath:file.path,name:szFileName,type:file.type,toLocal:true})?.then((szFilePath)=>{
                                    mEditor.current?.chain().focus().setImage({src: 'atom://' +szFileName}).run()
                                    mEditor.current?.commands.blur()
                                })
                            }else{
                                fileToBase64(file).then(r => {
                                    const id = crypto.randomUUID();
                                    model.addImg(id, r)
                                    mEditor.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                                    mEditor.current?.commands.blur()
                                })
                            }
                        });
                    },
                    onDisabledImagePaste: text => {
                        console.log('text: ', text);
                        // add text to editor if you want, or display an error/upselll message
                    },
                    onImageDrop: files => {
                        files.forEach(file => {
                            fileToBase64(file).then(r => {
                                const id = crypto.randomUUID();
                                model.addImg(id, r)
                                mEditor.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                                mEditor.current?.commands.blur()
                            })
                        });
                    },
                };
            },
        }),
        TaskList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },

        }),
        TaskItem.configure({
            nested: true,
        }),
        HorizontalRule.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        Blockquote.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        // Hyperlink.configure({}),
        getHyperlinkExtension(null),
        FontFamily,
        CodeBlockLowlight.extend({
            addNodeView() {
                return ReactNodeViewRenderer(CodeBlockComponent);
            },
            addAttributes() {
                return {
                    id: {
                        default: () => crypto.randomUUID(),
                        parseHTML: (element) => {
                            return (
                                element?.lastElementChild?.getAttribute("id") ||
                                element?.getAttribute("data-id") ||
                                crypto.randomUUID()
                            );
                        },
                        renderHTML: (attributes) => {
                            if (!attributes.id) return {};
                            return { "data-id": attributes.id };
                        },
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                    language: {
                        default: 'Auto'
                    }
                };
            }
        }).configure({lowlight}),
        DeeplinkNode.configure({
            fontSize: '15px',
            marginTopImg:'3.5px',
            containerMarginTop:'-1px'
        }),
        GlobalDragHandle.configure({
            dragHandleWidth: 20, // default
            showWhenNotEditable: true,

            // The scrollTreshold specifies how close the user must drag an element to the edge of the lower/upper screen for automatic
            // scrolling to take place. For example, scrollTreshold = 100 means that scrolling starts automatically when the user drags an
            // element to a position that is max. 99px away from the edge of the screen
            // You can set this to 0 to prevent auto scrolling caused by this extension
            scrollTreshold: 100, // default

            // The css selector to query for the drag handle. (eg: '.custom-handle').
            // If handle element is found, that element will be used as drag handle.
            // If not, a default handle will be created
            dragHandleSelector: ".drag-handle", // default is undefined


            // Tags to be excluded for drag handle
            // If you want to hide the global drag handle for specific HTML tags, you can use this option.
            // For example, setting this option to ['p', 'hr'] will hide the global drag handle for <p> and <hr> tags.
            excludedTags: [], // default

            // Custom nodes to be included for drag handle
            // For example having a custom Alert component. Add data-type="alert" to the node component wrapper.
            // Then add it to this list as ['alert']
            //
            customNodes: [],
            callback:async (szAction:any,data:any)=>{

            }
        }),
    ]

    let editor = useEditor({
        autofocus: false,
        injectCSS: true,
        editable: true,
        extensions: extensions,
        editorProps: {
            attributes: {
                // class: '',
            },
            handleDOMEvents:{
                keydown:(view,event)=>{
                    if (event.key == '@'){
                        window.showPopupCardList(mEditor.current);
                    }else if (event.key == KEYS.BACKSPACE){
                        window.closePopupCardList();
                    }
                },
                dragstart:(view,event)=>{
                    //只能拖动的是纯文字。。。
                    const {from,to} = view.state.selection;
                    const selectedText = view.state.doc.textBetween(from, to, '\n', ' ');
                    if (!selectedText){
                        event.preventDefault();
                        event.stopPropagation();
                    }else{
                        global.g_isDragFromCardText = true;

                        setTimeout(()=>{
                            global.g_isDragFromCardText = false;
                        },2000)
                    }
                },
            },
            handlePaste(view, event, slice) {
                if (mEditor.current){
                    return handlePaste(mEditor.current,view,event,slice);
                }
            },
            clipboardTextParser(text, context, plain, view) {
                if (mEditor.current) {
                    return handleClipboard(mEditor.current,text);
                }
            },
            transformPastedText(text, plain, editorView) {
                return handleTransformPastedText(text, plain, editorView);
            },
            transformPastedHTML(html,editorView) {
                if (event?.clipboardData?.files?.length > 0){
                    //有文件的时候，不处理html.....
                    return '';
                }
                return handleTransformPastedHTML(html,editorView,props.element.id)
            },
            handleClick(e, r, k) {
                if (!props.element?.customData?.generationData?.isEditable)return;

                // const {from, to} = e.state.selection
                // if (to > from) {
                //     setPos([true, r])
                // } else {
                //     setPos([false, 0])
                // }
                //取消选中
                mEditor.current.chain().focus().setTextSelection(r).run();

                //记录点击的位置
                const divScroll = document.getElementById('div-cardedit-scroll-'+props.element.id);
                global.g_mapCardPos[props.data.id] = {pos:r,scroll:divScroll?.scrollTop || 0};

                postMessage(EVENT_CLOSE_IMAGE_ACTION);
                window.closePopupCardList();
            },
        },
        onUpdate(editor0) {
            if (!mEditor.current){
                mEditor.current = editor0.editor;
            }

            let tempArr = []
            let reverseInlineLatexArr = []
            mEditor.current.state.doc.descendants((node, pos) => {
                if (node.type.name === "paragraph" && node.content) {
                    const content = node.content.content; // ProseMirror Node 的子节点数组在 content.content 里

                    for (let i = 0; i < content.length - 1; i++) {
                        const current = content[i];
                        const next = content[i + 1];
                        if (
                            current.type.name === "latexInline" && current.attrs?.dollarBoundaries===1 &&
                            next.type.name === "text" &&
                            /^\d/.test(next.text || "")) {
                            tempArr.push(current)
                        }
                    }
                } else if (node.type.name === "latexInline" && tempArr?.[0]?.attrs?.id === node.attrs.id) {
                    reverseInlineLatexArr.push({
                        node: node,
                        pos: pos
                    })
                    tempArr.shift()
                }
            });
            if (reverseInlineLatexArr.length > 0) {
                for (let i = 0; i < reverseInlineLatexArr.length; i++) {
                    const element = reverseInlineLatexArr[i];
                    const textNode = mEditor.current.state.schema.text(`$${element.node.attrs.metaData}$`);

                    // 用 replaceWith 把原来的节点替换掉
                    const tr = mEditor.current.state.tr.replaceWith(element.pos, element.pos + element.node.nodeSize, textNode);
                    mEditor.current.view.dispatch(tr);
                }
            }

            if (!mIsEditStatsUpdate) {
                if (timer) clearTimeout(timer)
                timer = setTimeout(() => {
                    if (editor) {
                        let html = editor.getHTML()
                        /** 最后为图片时， 作为p标签 */
                        if (/\<img[^\>]+\>$/.test(html)) {
                            editor?.commands.setContent(html + '<p></p>')
                        }

                        //这里还要刷新画布上的右侧栏.
                        postMessage(EVENT_REFRESH_SLIDER_INFO,{...props.data,doc:html});
                    }
                }, 500)

                updateElementHeight('', 'tiptap');
                if (global.g_isDrawCardUpdate) {
                    updateEditCard();
                    global.g_isDrawCardUpdate = false;
                }

            }
            mIsEditStatsUpdate = false;
        },
        onSelectionUpdate(editororororororor) {
            const editor = editororororororor.editor;
            const { from, to } = editor.state.selection;
            const selectNode = []
            editor.state.doc.nodesBetween(from, to, (node, pos) => {
                // console.log('---node--', node);

                selectNode.push({
                    nodeType: node.type.name,
                })
            });
            // console.log('selectNode', selectNode);

            if (selectNode.length > 1 || (selectNode.length === 1 && selectNode[0].nodeType !== 'image')) {
                setIsShowTextBar(true);

            } else if (selectNode.length === 1 && selectNode[0].nodeType === 'image') {
                setIsShowTextBar(false);
            }

            let szName = editor.state.selection.node?.type?.name;
            if ('deeplink' == szName || to == from){
                onHiddenBubbleMenu();
            }else{
                const szTxt = editor.state.doc.textBetween(from,to);
                // console.log('xx****************8xx',szTxt);
                props.onTextSelection(from!=to,editor,updateEditCardHtml,syncNoteData,props.element,props.data,onHiddenBubbleMenu,onAction);

                if (window.updateBubblePosition){
                    window.updateBubblePosition();
                }
            }

            //先删除----
            delete window.cardEditSelected;

            if (from != to){
                global.g_currentSelectedText = editor.state.doc.textBetween(from,to);
                window.globalCardEditSelected = async ({x,y})=>{
                    const item = {
                        createTime:Date.now(),
                        doc:'',
                        id:generateUUID2(),
                        name:global.g_currentSelectedText,
                        tags:[],
                        type:'card',
                        updateTime:Date.now()
                    }
                    await updateCard(item);
                    const szLink = createCopyLink('library',item.id,'card',null,null,null,false)
                    //2.添加链接
                    editor.commands.setLink({href: szLink, target: '_blank'});
                    postMessage(EVENT_TEST_ONDRAG_NOTE,{...item,x:x,y:y})
                }
            }

            // const resolvedPos = editor.state.doc.resolve(from+1);
            // // 获取当前节点
            // const currentNode = resolvedPos.node();
            // console.log('---currentNode',currentNode,from, to );
        },
        onCreate(editor0) {
            // console.log('onCreate')
            mEditor.current = editor0.editor;
            editor0.editor.id = props.element.id;
            editor0.editor.cardId = props.element.customData?.generationData?.id;
            editor0.editor.from = 'cardEdit'
            editor0.editor.commands.setContent(replaceLatexInParagraph(migrateInlineCodeToOfficial(props.data.html)));
            editor0.editor.commands.setTextSelection(0);
            // editor0.editor.view.dom.classList.remove('ProseMirror');
            editor0.editor.view.dom.classList.add('ProseMirror-card');
            if (!hasTitle){
                editor0.editor.view.dom.style.marginTop = '-9px';
            }else{
                editor0.editor.view.dom.style.marginTop = '';
            }
            editor0.editor.view.dom.style.minHeight = '100%';//props.element.height+'px';

            editor0.editor.isShowSliderTip = true;//显示侧栏提示
            editor0.editor.forceUpdate = ()=>{
                updateEditCard();
            }

            editor0.editor.view.dom.onwheel = (event) => {
                if (event.ctrlKey || event.metaKey) {
                    props.onWheel(event);
                }
            };
            if (props.element.customData.generationData.isEditable) {
                // editor?.commands.focus();
                if (!global.g_mapCardPos[props.data.id]){
                    setTimeout(() => {
                        txtTitleRef.current?.focus();
                    }, 50)
                }
            }

            //第一次，根据element的高度调整一次内容的高度..
            const nElementHeight = props.element.height;
            // console.log('****根据element的高度:'+nElementHeight);
            if (divContainerRef.current) {
                divContainerRef.current.style.height = (nElementHeight - DEFAULT_TOOLBAR_HEIGHT - 20 - HEIGHT_OFFSET) + 'px'
            }
        },
        onBlur(editor) {
            console.log('onblur............................updateEditCard...');
            if (!global.g_isImageActionMouseDown) {
                postMessage(EVENT_CLOSE_IMAGE_ACTION);
            }
            global.g_isImageActionMouseDown = false;

            updateEditCard();

            updateEditCardHtml();
            props.app.pushHistory();

            // onHiddenBubbleMenu();

            //移除blockmenu 移除blockmenu移除blockmenu移除blockmenu移除blockmenu移除blockmenu移除blockmenu移除blockmenu移除blockmenu移除blockmenu
            //不知道什么情况下 弹窗中的 /  这里也会响应？？？？？？？？--移不掉。。。。。
            // const nIndex = mEditor.current.extensionManager.extensions.findIndex(p=>p.name == 'blockMenu');
        },
        onDestroy() {
            // console.log('onDestroy   xxxxx');
            // updateEditCard();
        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });

    /**
     * 隐藏这个固定的菜单
     */
    const onHiddenBubbleMenu = ()=>{
        props.onTextSelection(false,null,null,null,null,null,null,null)
    }

    const onAction = (data)=>{
        if (data == 'h1Changed'){
            refreshH1Title();
        }
    }

    if (props.element.customData.generationData.libraryType == 'journal') {
        TITLE_MARGIN_TOP = 0;
    }

    /**
     * 更新拖动的可见状态
     */
    const updateCardDragVisible = () => {
        const divCustomDrag = document.getElementById(CARD_EDIT_DRAG_ID_PRE + props.element.customData.generationData.id);
        if (divCustomDrag) {
            if (props.element.customData.generationData.isEditable) {
                divCustomDrag.style.visibility = "visible";
            } else {
                divCustomDrag.style.visibility = "hidden";
            }

            // console.log(document.querySelector('.excalidraw__embeddable-container').style.transform.scale)
            let x = props.element.width - props.element.width * global.g_canvasZoomValue;
            let y = props.element.height - props.element.height * global.g_canvasZoomValue;

            // divCustomDrag.style.transform = `translate(${-40}px, ${-100}px) scale(${global.g_canvasZoomValue})`
        }
    }
    /**
     * 更新高度
     */
    const updateElementHeight = (szNewHtml = '', from: any) => {
        if (global.g_isPresentMode) return;
        if (!props.element.customData.generationData.isExpand) return;
        if (editor == null) return;
        // if (!props.element.customData.generationData.isEditable)return;

        if (!props.element.customData.generationData.isFixedSize) {
            //没有调整过大小，自动高度...
            let height = txtTitleRef.current?.clientHeight + editor?.view.dom.clientHeight;
            if (height == 0){

            }else{
                if (height < 80) {
                    height = 80;
                }

                if (height > MAX_AUTO_CARD_EDIT_HEIGHT) {
                    height = MAX_AUTO_CARD_EDIT_HEIGHT;
                }
                let eleHeight = height + DEFAULT_TOOLBAR_HEIGHT + 24 + MARGIN_TOP_CONTENT + 12 + TITLE_MARGIN_TOP;

                if (divContainerRef.current){
                    divContainerRef.current.style.height = (height + 24 - HEIGHT_OFFSET + MARGIN_TOP_CONTENT) + 'px';
                }

                if (from != 'tiptap') {
                    props.element.customData.generationData.name = cardTitle;//divTitleRef.current?.innerText;
                }

                if (szNewHtml) {
                    props.element.customData.generationData.html = imgServer.parserImgFromHtml(szNewHtml,props.element.id);
                }
                //
                if (props.updateElementCallback) {
                    props.updateElementCallback(props.element, {height: eleHeight})
                }
            }

        } else {
            setTimeout(() => {
                if (divContainerRef.current) {
                    divContainerRef.current.style.height = (props.element.height - DEFAULT_TOOLBAR_HEIGHT - 20 - HEIGHT_OFFSET + MARGIN_TOP_CONTENT) + 'px';
                    if (props.updateElementCallback) {
                        props.updateElementCallback(props.element, {height: props.element.height})
                    }
                }
            }, 300);
        }

        //同步数据...
        syncNoteData(szNewHtml);
    }

    useEffect(() => {

        if (props.element) {
            if (props.element.customData.generationData.isExpand == undefined) {
                props.element.customData.generationData.isExpand = true;//没有的默认为展开状态...
                props.element.customData.generationData.isFixedSize = true;//默认为固定大小
            }
            setImgRotate(props.element.customData.generationData.isExpand ? 'rotate(0deg)' : 'rotate(-90deg)')
        }


        const handleBlockLinkClick = (event) => {
            if (props?.data?.id === event?.detail?.noteId && props?.data?.id !== undefined) {
                // 直接跳转
                const selectedNP = editor.$doc.querySelectorAll(event.detail.blockType, { id: event.detail.blockId })[0]
                editor.chain().blur().setNodeSelection(selectedNP.pos - 1).scrollIntoView().run();
                // let els = document.querySelector(`.ProseMirror [data-id="${event.detail.blockId}"]`)
                // console.log(1212,els?.outerHTML);
                // debugger
                // els?.scrollIntoView({ block: 'start' })
            } else {
                // 关闭当前弹窗后跳转
                document.dispatchEvent(new CustomEvent('outsideBlockLinkClick', {
                    detail: {
                        noteId: event.detail.noteId,
                        blockId: event.detail.blockId,
                        blockType: event.detail.blockType
                    }
                }))
            }
        }
        document.addEventListener('blockLinkClick', handleBlockLinkClick);

        window.refreshEditCardList[`refreshCardEdit_${props.element.id}`] = refreshDataForGlobal;

        return ()=>{
            unSubscribe(EVENT_SYNC_REFRESH_DRAW_CARDEDIT);
            delete window.refreshEditCardList[`refreshCardEdit_${props.element.id}`];
            document.removeEventListener('blockLinkClick', handleBlockLinkClick);
        }

    }, [])

    useEffect(()=>{
        refreshH1Title();
    },[hasTitle])

    /**
     * 按键
     * @param event
     */
    function onKeyDown(event:any){
        // debugLog('actionProperties',event);
        if (event.key == KEYS.ESCAPE){
            window.closePopupCardList();
        }
    }

    useEffect(() => {
        //激活...
        recvMessage(EVENT_ACTIVE_CARD_EDIT, (msg, data) => {
            if (data.data.id == props.data.id) {
                editor?.commands.focus();
            }
        })

        recvMessage(EVENT_RESIZING_CARD, (msg, data) => {
            if (data.data.element.id == props.element.id) {
                const nElementHeight = data.data.element.height;
                if (divContainerRef.current) {
                    divContainerRef.current.style.height = (nElementHeight - DEFAULT_TOOLBAR_HEIGHT - HEIGHT_OFFSET + MARGIN_TOP_CONTENT) + 'px'
                }
            }
        })

        recvMessage(EVENT_UPDATE_NOTE_HEIGHT, (msg, data) => {
            if (props.element.id == data.data.id) {
                props.data.html = data.data.customData.generationData.html;
                updateElementHeight(data.data.customData.generationData.html);
            }
        })

        recvMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB, (msg, data) => {
            if (props.element.id == data.data.id) {
                let szHtml = data.data?.customData?.generationData?.html;
                if (!szHtml) {
                    szHtml = imgServer.parserImgFromHtml(mEditor.current?.getHTML(),props.element.id);
                }
                props.data.html = szHtml;
                updateElementHeight(szHtml);
                updateEditCard();
            }
        })

        recvMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO, (msg, data) => {
            if (props.element.id == data.data.id || props.element.customData?.generationData?.id == data.data.id) {
                let szHtml = data.data?.customData?.generationData?.html;
                props.data.name = data.data?.customData?.generationData?.name;
                setCardTitle(data.data?.customData?.generationData?.name);
                props.data.html = szHtml;
                editor?.commands.setContent(props.data.html);

                updateElementHeight(szHtml);
                updateEditCard(data.data?.customData?.generationData?.name);
            }
        })

        document.body.addEventListener('keydown',onKeyDown);
        setIsEditable(props.element.customData.generationData.isEditable);

        return () => {
            unSubscribe(EVENT_ACTIVE_CARD_EDIT);
            unSubscribe(EVENT_REFRESH_EDIT_CARD);
            unSubscribe(EVENT_RESIZING_CARD);
            unSubscribe(EVENT_UPDATE_CANVAS_NOTE_TO_DB);
            unSubscribe(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO);
            document.body.removeEventListener('keydown',onKeyDown);
            // unSubscribe(EVENT_CANVAS_SELECTION_CHANGED)
        }
    });

    useEffect(() => {
        //这🤢玩意，latexblock从弹窗中不会更新？？？必须置空一下。。。。
        editor?.commands.setContent('');
        editor?.commands.setContent(migrateInlineCodeToOfficial(props.data.html));
        setCardTitle(props.data.name);

        //查询是否有标题.
        getCardById(props.data.id).then(res=>{
            if (res){
                if (res.hasTitle != undefined){
                    setHasTitle(res.hasTitle);
                    props.data.hasTitle = res.hasTitle;
                    props.element.customData.generationData.hasTitle = res.hasTitle;
                }
            }
        })


        recvMessage(EVENT_CANVAS_SELECTION_CHANGED, (msg, data) => {
            // console.log("setIsEnableEvents   " + Object.keys(data.data.selectedElements).length)
            // setIsEnableEvents(Object.keys(data.data.selectedElements).length <= 1);
        })

        recvMessage(EVENT_CANVAS_EXPAND_STATS_CHANGED,(msg,data)=>{
            if (data.data.ids.includes(props.element.id)){
                setIsExpand(data.data.isExpand);
            }
        })

        //右侧栏的同步...
        recvMessage(EVENT_SYNC_REFRESH_DRAW_CARDEDIT,(msg,data)=>{
            // if (props.element.id == data.data.id || props.element.customData?.generationData?.id == data.data.id) {
            //     let szDoc = data.data.doc;
            //     props.data.name = data.data.name;
            //     setCardTitle(data.data.name);
            //     props.data.html = szDoc;
            //     mEditor.current.commands.setContent(szDoc);
            //
            //     if (!data.data.isAAAAA){
            //         updateElementHeight(szDoc);
            //         updateEditCard(data.data?.customData?.generationData?.name || data.data.name,false);//不要保存到数据库，那边已经保存了.
            //     }
            // }
        })

        window.refreshList['update_sync_refresh_draw_cardedit_'+props.element.id] = (data)=>{
            if (props.element.id == data.id || props.element.customData?.generationData?.id == data.id) {
                let szDoc = data.doc;
                props.data.name = data.name;
                setCardTitle(data.name);
                props.data.html = szDoc;
                mEditor.current.commands.setContent(szDoc);

                if (!data.isAAAAA){
                    updateElementHeight(szDoc);
                    updateEditCard(data?.customData?.generationData?.name || data.name,false);//不要保存到数据库，那边已经保存了.
                }
            }
        }


        setTimeout(()=>{
            window.hookATags();
        },500);

        window.refreshList['updateTheme_cardEdit_'+props.element.id] = forceRefreshSelf;

        return ()=>{
            unSubscribe(EVENT_CANVAS_SELECTION_CHANGED);
            unSubscribe(EVENT_CANVAS_EXPAND_STATS_CHANGED);
            unSubscribe(EVENT_SYNC_REFRESH_DRAW_CARDEDIT);
            delete window.refreshList['updateTheme_cardEdit_'+props.element.id];
            delete window.refreshList['update_sync_refresh_draw_cardedit_'+props.element.id];
        }

    }, [props.data]);

    useEffect(()=>{
        setTimeout(()=>{
            updateTextAreaHeight();
        },10)
        cardTitleRefRefRefRefRefRef.current = cardTitle;
    },[cardTitle])

    useEffect(()=>{
        setTimeout(()=>{
            updateTextAreaHeight();
            if (!isEditable){
                onHiddenBubbleMenu();
            }
        },10)
    },[isEditable])

    useEffect(() => {
        setTimeout(() => {
            editor?.setEditable(props.element.customData.generationData.isEditable);
            editor?.commands.setTextSelection(-1);

            if (!props.element.customData.generationData.isEditable){
                onHiddenBubbleMenu();
                try {
                    document.querySelectorAll('.drag-handle').forEach((el: any) => el.classList.add('hide'));
                } catch (e) {}
            }
        }, 10)
    }, [props.element.customData.generationData.isEditable])

    useEffect(() => {
        setIsHiddenInLibrary(props.element.customData.generationData.isHidden == 1)
    }, [props.element.customData.generationData.isHidden])

    useEffect(() => {
        setImgRotate(props.element.customData.generationData.isExpand ? 'rotate(0deg)' : 'rotate(-90deg)');
        setIsExpand(props.element.customData.generationData.isExpand);
    }, [props.element.customData.generationData.isExpand])

    useEffect(() => {
        if (divContainerRef && divContainerRef.current) {
            if (divContainerRef.current?.clientHeight == 0) {
                //之前是折叠保存的。高度为0
                let nDefaultHeight = props.element.customData.generationData.originHeight || 0;
                if (nDefaultHeight < 50) {
                    nDefaultHeight = 180;
                }
                divContainerRef.current.style.height = (nDefaultHeight - DEFAULT_TOOLBAR_HEIGHT - HEIGHT_OFFSET + MARGIN_TOP_CONTENT) + 'px'
            }
        }
    }, [props.element.height])

    //强制刷新主题--这里还要切换背景和内容颜色。
    function forceRefreshSelf(){
        if (isDefaultBackgroundColor(props.element.backgroundColor)) {
            props.element.backgroundColor = getNoteElementBackgroundColor();

            const ele = props.app.getSceneElements().find(p=>p.id == props.element.id);
            mutateElement(ele,{backgroundColor:getNoteElementBackgroundColor()})
        }

        forceUpdate();
    }

    function refreshH1Title(){
        if (mEditor.current){
            if (!hasTitle){
                if (mEditor.current.view.dom.firstChild.classList.contains('heading-container') && mEditor.current.view.dom.firstChild.innerHTML.includes('h1')){
                    mEditor.current.view.dom.style.marginTop = '-9px';
                    mEditor.current.view.dom.firstChild.style.marginBottom = '15px';
                }else{
                    mEditor.current.view.dom.style.marginTop = '';
                }
            }else{
                mEditor.current.view.dom.style.marginTop = '';
            }
        }
    }


    /**
     * 全局刷新
     * @param data
     */
    const refreshDataForGlobal = (data)=>{
        let szDoc = data.doc;
        props.data.name = data.name;
        setCardTitle(data.name);
        props.data.html = szDoc;
        mEditor.current.commands.setContent(szDoc);
    }

    /**
     * sliderDraw 给draw 发送消息
     * @param szAction
     * @param data
     */
    const sendMessageFromSliderDraw = (szAction,data)=>{
        window.parent.postMessage({action:szAction,data:data})
    }

    /**
     * draw 给 sliderDraw发消息
     * @param szAction
     * @param data
     */
    const sendMessageFromDraw = (szAction,data)=>{
        const iframe = document.getElementById('iframe-slider-drawindex-container');
        if (iframe){
            iframe.contentWindow.postMessage({action:szAction,data:data})
        }
    }

    /**
     * 是否在右侧栏
     */
    const isInSlider = ()=>{
        return window.location.href.includes('sliderDraw');
    }

    /**
     * 更新卡片
     */
    const updateEditCard = (szTitle:any,bSaveDb = true) => {
        return new Promise(async (resolve, reject) => {
            const doc = imgServer.parserImgFromHtml(mEditor.current?.getHTML() as string,props.element.id);
            const name = szTitle || cardTitleRefRefRefRefRefRef.current || '';//divTitleRef.current?.innerText;这玩意异步更新真是的让人🤢
            const dbCard = await getCardById(props.data.id, false);
            let card = {
                ...props.data,
                type: props.data.libraryType || 'card',
                doc: doc,
                name: name
            }
            if (dbCard) {
                card = {...dbCard};
            } else {
                card = {...props.data};
            }
            if (!card.type) {
                card.type = 'card';
            }
            card.name = name;
            card.doc = doc;

            props.element.customData.generationData.name = name;
            props.element.customData.generationData.html = doc;
            // props.element.customData.generationData.infoNotes = card.infoNotes;
            // props.element.customData.generationData.infoUrl = card.infoUrl;

            //更新侧栏...
            postMessage(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD, card);

            if (bSaveDb){
                updateCard(card).then(res => {
                    resolve(card);
                    //刷新库列表
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                })
            }else{
                resolve(card);
                //刷新库列表
                postMessage(EVENT_REFRESH_LIBRARY_LIST);
            }
        })
    }

    /**
     * 只更新html
     */
    const updateEditCardHtml = ()=>{
        const doc = imgServer.parserImgFromHtml(editor?.getHTML() as string,props.element.id);
        props.element.customData.generationData.html = doc;

        //更新一下，标记有更新。。。。
        props.app.signUpdateElement(props.element.id,{versionNonce:randomInteger()})

        //隐藏浮窗
        // setTimeout(()=>{
        //     onHiddenBubbleMenu();
        // },100)

        const name = cardTitleRefRefRefRefRefRef.current || '';
        const card = {
            ...props.element.customData.generationData,
            name: name,
            doc: doc
        }
        card.type = props.element.customData.generationData.libraryType || 'card';
        refreshOtherSameCard(card);
    }

    //空白地方插入p
    function onEditDivClick(e) {
        setTimeout(() => {
            const selection2 = window.getSelection()
            if (selection2?.type === 'Range' && pos[0]) {
                editor?.commands.focus(pos[1])
                setPos([false, 0])
            }

            let html = editor?.getHTML()
            /** 最后为图片时， 作为p标签 */
            if (!/\<\/p\>$/.test(html)) {
                editor?.commands.setContent(html + '<p></p>')
            }
        }, 10)
    }

    /**
     * 是否展开了卡片
     */
    function isExpandNode() {
        return props.element.customData.generationData.isExpand == true;
    }

    /**
     * 卡片点击编辑
     */
    function onCardClick(){
        // console.log('oncard-click');
        if (!props.element.customData.generationData.isEditable /*&& !mIsMoving.current*/) {//这个控制是啥？不知道什么用，取消了。。。20250320//
            setCardIsEditable();
        }
        mIsMoving.current = false;
        global.g_isCanvasCardMouseDown = false;
    }

    /**
     * 设置卡片可编辑
     */
    function setCardIsEditable() {
        if (global.g_isPresentMode) return;
        if (props.element.locked)return;

        global.g_isDrawCardEditing = true;

        mIsEditStatsUpdate = true;
        props.element.customData.generationData.isEditable = true;
        setIsEditable(props.element.customData.generationData.isEditable);
        editor?.setEditable(props.element.customData.generationData.isEditable);
        if (document.activeElement?.id != props.element.id){
            //非标题激活...
            editor?.commands.focus();
        }

        //更新这个element....
        const customData = {...props.element.customData};
        props.updateElementCallback(props.element, {customData: customData})

        updateCardDragVisible();

        //更新全局的这个.....
        global.g_currentCardEditElement = props.element;
        global.g_currentCardEditor = editor;

        //选中位置
        if (props.element.customData.generationData.isEditable && global.g_mapCardPos[props.data.id]){
            const possss = global.g_mapCardPos[props.data.id];
            console.log('****************');
            console.log(possss);
            setTimeout(()=>{
                const divScroll = document.getElementById('div-cardedit-scroll-'+props.element.id);
                if (divScroll){
                    divScroll.scrollTo(0,possss.scroll);
                    console.log('div-scroll');
                }
            },10)

            setTimeout(()=>{
                mEditor.current.commands.setTextSelection(possss.pos);
                console.log('settextselection');
            },50)
        }
    }

    // 滚动到指定位置---总是全局的在滚动.SHIT-
    function scrollToPosition(position) {
        // 1. 将光标移动到指定位置
        mEditor.current.commands.setTextSelection(position)

        // 2. 获取当前光标所在的 DOM 节点
        const selection = window.getSelection()
        const range = selection.getRangeAt(0)
        const node = range.startContainer

        // 3. 确保节点是可滚动的元素
        if (node.nodeType === Node.TEXT_NODE) {
            const parentElement = node.parentElement

            // 4. 滚动到该元素
            if (parentElement) {
                parentElement.scrollIntoView({ behavior: 'smooth', block: 'center',inline: 'nearest' })
            }
        }
    }


    /**
     * 同步数据...
     */
    function syncNoteData(szHtml: any = null,bForceSave = false) {
        //它有焦点才需要发送同步的消息...
        if (editor?.isFocused || document.getElementById(props.element.id)?.id == document.activeElement?.id || txtTitleRef.current?.isFocused || bForceSave) {
            const title = txtTitleRef.current?.value;//divTitleRef.current?.innerText;
            const card = {
                ...props.element.customData.generationData,
                name: title,
                doc: szHtml || imgServer.parserImgFromHtml(editor?.getHTML(),props.element.id)
            }
            card.type = props.element.customData.generationData.libraryType || 'card';
            postMessage(EVENT_SYNC_NOTE_DATA, {...card});

            //更新别的所有..
            refreshOtherSameCard(card);

            //更新
            if (!isFirstFocus.current){
                getCardById(card.id).then(ressss=>{
                    if (ressss){
                        card.tags = ressss.tags;
                        if (ressss.formatDate){
                            card.formatDate = ressss.formatDate;
                        }
                    }
                    updateCard(card).then(rr=>{
                        if (isInSlider()){
                            sendMessageFromSliderDraw("UPDATE_CARD_FROM_DRAW",card);
                        }else{
                            //发送消息给右侧栏的画布
                            sendMessageFromDraw("UPDATE_CARD_FROM_DRAW",card);
                        }
                    })
                })
            }
            isFirstFocus.current = false;
        }
    }

    function getCaretPosition(element) {
        let range, node, selection, offset,
            charIndex = 0,
            rangeCount;

        if (window.getSelection) {
            selection = window.getSelection();
            if (selection.rangeCount > 0) {
                range = selection.getRangeAt(0);
                if (range.commonAncestorContainer.parentNode === element) {
                    return charIndex + range.startOffset;
                }
                node = range.commonAncestorContainer;
                rangeCount = 0;
                while (node) {
                    if (node.nodeType === 3) {
                        offset = node.data.length;
                    } else {
                        offset = node.childNodes.length;
                    }
                    charIndex += offset;
                    if (node === element) {
                        throw new Error('element should be child node of commonAncestorContainer');
                    }
                    node = node.parentNode;
                }
                return charIndex - rangeCount;
            }
        } else if (document.selection && document.selection.createRange) {
            range = document.selection.createRange();
            return range.text.length;
        }
        return 0;
    }

    function setCursorPosition(element, index) {
        if (window.getSelection) {
            // 清除所有选区
            window.getSelection().removeAllRanges();

            // 创建一个新的空范围
            var range = document.createRange();

            // 选择元素的某个子节点，比如文本节点
            var selectNode = element.childNodes[0];
            range.selectNode(selectNode);

            // 使用修改光标位置的索引值
            var charIndex = index;
            if (charIndex >= 0) {
                // 如果索引值有效，则移动光标到指定位置
                if (selectNode.nodeType == 3) {
                    // 如果是文本节点，根据索引值移动光标
                    if (charIndex <= selectNode.textContent.length) {
                        range.setStart(selectNode, charIndex);
                        range.setEnd(selectNode, charIndex);
                    } else {
                        console.warn("The cursor position index is out of bounds.");
                    }
                } else {
                    // 如果不是文本节点，尝试下一个子节点
                    var child = selectNode.childNodes[charIndex];
                    range.setStart(child, 0);
                    range.setEnd(child, 0);
                }
            }

            // 应用这个范围
            var selection = window.getSelection();
            selection.addRange(range);
        }
    }

    /**
     * 更新文本框高度
     */
    const updateTextAreaHeight = ()=>{
        if (txtTitleRef.current){
            txtTitleRef.current.style.height = '32px'; //!importment........... 退格高度问题....

            if (isEditable){
                txtTitleRef.current.style.display = 'inherit';

                if (!cardTitle){
                    txtTitleRef.current.style.height = '32px';
                }else{
                    txtTitleRef.current.style.height = (txtTitleRef.current.scrollHeight) + 'px';
                }
            }else{
                if (!cardTitle){
                    txtTitleRef.current.style.height = '0px';
                    txtTitleRef.current.style.display = 'none';
                }else{
                    txtTitleRef.current.style.display = 'inherit';
                    if (txtTitleRef.current.scrollHeight == 0){
                        txtTitleRef.current.style.height = calcCardTitleHeight(props.element.width - 52,txtTitleRef.current.value) + 'px';
                    }else{
                        txtTitleRef.current.style.height = (txtTitleRef.current.scrollHeight) + 'px';
                    }
                }
            }

            if (!hasTitle){//没有标题
                txtTitleRef.current.style.display = 'none';
            }
        }
    }

    const getBubbleMenuOffset = ()=>{
        let offsetX = 1400*(props.state.zoom.value-1)*props.state.zoom.value;
        let offsetY = 1000*(props.state.zoom.value-1)*props.state.zoom.value;
        return [offsetX,offsetY]
    }

    /**
     * 刷新画布上的别的。
     * @param card
     */
    const refreshOtherSameCard = (card:any)=>{
        //更新别的所有..
        const arrayOthers:any = props.app.getSceneElementsOrigin().filter(p=>p.customData?.generationData?.id == props.data.id);
        arrayOthers.forEach(p=>{
            if (p.id != props.element.id){
                // postMessage(EVENT_SYNC_REFRESH_DRAW_CARDEDIT,{...card,isAAAAA:true});
                const refreshCallback = window.refreshEditCardList[`refreshCardEdit_${p.id}`];
                if (refreshCallback){
                    refreshCallback({...card});
                }
            }
        })
    }

    const showLink = ()=>{
        const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
        global.g_newCardTitle = text;

        let link = editor.getAttributes('link').href

        // window.showDialogCardLink({link, text}, (r: any) => {
        //     if (r?.delete) {
        //         editor.commands.unsetLink()
        //         // editor.commands.unsetHyperlink()
        //     } else if (r) {
        //         editor.commands.setLink({href: r.link, target: '_blank'})
        //         // editor.commands.setHyperlink({href: r.link, target: '_blank'})
        //     }
        //
        //     updateEditCardHtml();
        //     props.app.pushHistory();
        // })
        //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
        mEditor.current?.commands.blur();

        window.showDialogLink(link, 'card', (item) => {
            if (!item) {
                editor.commands.unsetLink()
                // editor.commands.unsetHyperlink()
            } else {
                editor.commands.setLink({href: item, target: '_blank'})
            }
            setTimeout(() => {
                window.hookATags();
            }, 600)

            updateEditCardHtml();
            syncNoteData(null,true);
            props.app.pushHistory();
        })
    }

    const renderTooltipsTag = async ()=>{

    }

    const hasShowTitle = ()=>{
        // (cardTitle || props.element.customData.generationData.isEditable)?'inherit':'none'
        if (cardTitle || props.element.customData.generationData.isEditable){

        }
    }

    const shouldProxyHoverHandleEventToCanvas = (event: React.MouseEvent) => {
        // When card is editable, the tiptap layer captures pointer events. If the user is
        // interacting with the hover-handle (blue dot), proxy the event to the canvas handlers.
        if (!isEditable) return false;
        try {
            const scenePointer = viewportCoordsToSceneCoords(event as any, props.state as any);
            const element: any = props.element;
            const centerX = element.x + element.width / 2;
            const centerY = element.y + element.height / 2;
            const [pointerX, pointerY] = rotate(
                scenePointer.x,
                scenePointer.y,
                centerX,
                centerY,
                -element.angle,
            );
            const hoverHandles = getHoverHandles({
                element,
                appState: props.state as any,
                size: 18,
            }) as any;
            return Object.values(hoverHandles).some((h: any) => {
                if (!h) return false;
                const range = [h.x, h.y, h.x + h.width, h.y + h.height];
                return (
                    pointerX > range[0] &&
                    pointerX < range[2] &&
                    pointerY > range[1] &&
                    pointerY < range[3]
                );
            });
        } catch {
            return false;
        }
    };

    /**
     * 边框颜色
     */
    const getBorderColor = ()=>{
        if (props.isSelected){
            return getElementSelectionBorderColor();
        }
        let szStrokeColor = props.element.strokeColor?.toUpperCase();
        if (szStrokeColor == "#EFEFEF" || szStrokeColor == "#FFFFFF"){
            szStrokeColor = "transparent";
        }
        return szStrokeColor;
    }

    const getBorderWidth = ()=>{
        if (props.isSelected){
            return 2/props.app.state.zoom.value;
        }
        return props.element.strokeWidth/(props.app.state.zoom.value);
    }


    return <div className={'div-placeholder'} id={'cardedit-container-' + props.element.id} style={{
        textAlign: "left",
        height: '100%',
        width:'100%',
        marginTop: '0px',
        // marginLeft: '-0.25px',
        // marginRight: '-0.6px',
        zIndex: '2006',
        // overflow: props.element.customData.generationData.isExpand?'visible':'hidden',
        overflow: 'hidden',
        background: props.element.backgroundColor,
        cursor: isEditable ? 'auto' : 'pointer',
        pointerEvents: isEnableEvents ? 'all' : 'none',
        padding:'0 2px 0 1px',//滚动条和boxshadow的inset
        boxShadow:`inset 0 0 0 ${getBorderWidth()}px ${getBorderColor()}`,
        minHeight: props.element.customData.generationData.isExpand ? (DEFAULT_TOOLBAR_HEIGHT) + 'px' : `${DEFAULT_COLLAPSE_HEIGHT_1}px`
    }}
                onClick={(e) => {
                    onEditDivClick(e);
                }}
                onMouseDown={(event) => {
                    const shouldProxy = shouldProxyHoverHandleEventToCanvas(event);
                    const isDragHandle = (event.target as HTMLElement)?.closest('.drag-handle');
                    if (!isEditable || shouldProxy) {
                        if (shouldProxy) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        if (isDragHandle) {
                            return; // Let the block drag handle its own mousedown -> dragstart
                        }
                        mIsMouseDown.current = true;
                        props.onMouseDown(event);
                    }
                    // mOffset.current.x = event.clientX;
                    // mOffset.current.y = event.clientY;

                }} onMouseMove={(event) => {
        const shouldProxy = shouldProxyHoverHandleEventToCanvas(event);
        const isDragHandle = (event.target as HTMLElement)?.closest('.drag-handle');
        if (!isEditable || mIsMouseDown.current || shouldProxy) {
            if (isDragHandle && !mIsMouseDown.current) {
                return;
            }
            props.onMouseMove(event);

            // let nOffsetX = Math.abs(event.clientX - mOffset.current.x);
            // let nOffsetY = Math.abs(event.clientY - mOffset.current.y);
            // console.log('offsetX:'+nOffsetX)
            // console.log('offsetY:'+nOffsetY)
            //
            // mOffset.current.x = event.clientX;
            // mOffset.current.y = event.clientY;

            if (mIsMouseDown.current) {
                mIsMoving.current = true;
            }
        }
        // updateCardDragVisible();
    }} onMouseUp={(event) => {
        if (!isEditable || mIsMouseDown.current) {
            props.onMouseUp(event);
        }
        mIsMouseDown.current = false;
    }} onDoubleClick={() => {
        // setCardIsEditable()
    }} onMouseEnter={() => {
        setIsTitleHoverd(true)
    }} onMouseLeave={() => {
        setIsTitleHoverd(false)
    }} onWheel={(event) => {

        let hasScrollView = false;
        const divMain = document.getElementById('div-cardedit-scroll-'+props.element.id);
        if (divMain && isEditable){
            hasScrollView = divMain.scrollHeight > divMain.clientHeight;
        }
        if (!hasScrollView){
            props.onWheel(event);
        }

    }}>

        {/*//工具栏*/}
        <div
            className={props.element.customData.generationData.isExpand ? 'div-card-edit-toolbar-title' : '' + ' cursor-pointer'}
            style={{
                height:(APP_WEB && props.element.customData.generationData.isExpand)?'0px':(props.element.customData.generationData.isExpand ? (DEFAULT_TOOLBAR_HEIGHT) + 'px' : `${DEFAULT_COLLAPSE_HEIGHT_1}px`),
                display: 'flex',
                alignItems: 'center',
                padding: '2px 22px 0px 22px',
                margin:'0 -2px',
                borderRadius: props.element.customData.generationData.isExpand ? '8px 8px 0 0' : '8px',
                pointerEvents: isEnableEvents ? 'all' : 'none',
                visibility: ((isEditable || isTitleHoverd) && !global.g_isPresentMode && !APP_WEB) ? 'visible' : 'hidden'
            }} onDoubleClick={(event) => {
            mIsEditStatsUpdate = true;
            event.preventDefault();
            event.stopPropagation();
            //转到侧栏
            updateEditCard().then(res => {
                postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data: res});
            })
        }} onMouseDown={(event) => {
            if (props.app.getSelectedElements().length == 1){
                props.onMouseDown(event)
            }

        }} onMouseMove={(event) => {
            if (props.app.getSelectedElements().length == 1){
                props.onMouseMove(event);
            }
        }} onMouseUp={(event) => {
            props.onMouseUp(event);
            mIsMouseDown.current = false;
        }}>
            <Tooltip placement="top" overlayClassName='font-size-12'
                     title={props.element.customData.generationData.isExpand ? t("Fold") : t("Unfold")} arrow={false}>
                <div className={'title-image-hover  cursor-pointer'} style={{marginLeft: '0px'}} onDoubleClick={(e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                }} onClick={(e) => {

                    mIsEditStatsUpdate = true;
                    if (imgRotate == 'rotate(0deg)') {
                        //折叠
                        setImgRotate('rotate(-90deg)');
                        if (props.updateElementCallback) {
                            const customData = {...props.element.customData};
                            customData.generationData.originHeight = props.element.height;
                            customData.generationData.isExpand = false;
                            props.updateElementCallback(props.element, {
                                height: DEFAULT_COLLAPSE_HEIGHT,
                                customData
                            }, true)
                        }
                    } else {
                        setImgRotate('rotate(0deg)');
                        //展开
                        const customData = {...props.element.customData};
                        customData.generationData.isExpand = true;
                        let nDefaultHeight = props.element.customData.generationData.originHeight || 0;
                        if (nDefaultHeight < 50) {
                            nDefaultHeight = 180;
                        }
                        if (divContainerRef.current?.clientHeight == 0) {
                            //之前是折叠保存的。高度为0
                            divContainerRef.current.style.height = (nDefaultHeight - DEFAULT_TOOLBAR_HEIGHT - HEIGHT_OFFSET + MARGIN_TOP_CONTENT) + 'px'
                        }
                        props.updateElementCallback(props.element, {height: nDefaultHeight, customData}, true)
                    }
                }}>
                    <img className={'img-16'} style={{
                        transform: imgRotate,
                        pointerEvents: isEnableEvents ? 'all' : 'none',
                    }}
                         src={getImagePathWithTheme('card_dropdown',true)}/>
                </div>
            </Tooltip>

            <Tooltip placement="top" overlayClassName='font-size-12' title={t("Open in fullscreen")} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{
                         pointerEvents: isEnableEvents ? 'all' : 'none',
                         display: isExpandNode() ? 'inherit' : 'none'
                     }}
                     onClick={() => {
                         //全屏
                         updateEditCard().then(res => {
                             // global.g_currentNoteFullScreen = true;
                             // global.g_isCurrentNoteFullScreenInCanvas = true;
                             // setCardFullScreen(true);
                             // openEditor(props.data.id);

                             if (isInSlider()){
                                 window.parent.navigate(getCardPath(),{cardId:props.data.id});
                             }else{
                                 window.navigate(getCardPath(),{cardId:props.data.id});
                             }

                             setTimeout(()=>{
                                 global.g_currentRecentId = props.data.id;
                                 postMessage(EVENT_REFRESH_RECENTS);
                             },100)

                         })
                     }}>
                    <img className={'img-16 '}
                         src={getImagePathWithTheme('draw_card_full_screen',true)}/>
                </div>
            </Tooltip>

            <Tooltip placement="top" overlayClassName='font-size-12' title={t("Add to sidebar")} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{
                         pointerEvents: isEnableEvents ? 'all' : 'none',
                         display: isExpandNode() ? 'inherit' : 'none'
                     }}
                     onClick={(event) => {
                         //侧栏打开..
                         updateEditCard().then(res => {
                             postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data: res});
                         })
                     }}>
                    <img className={'img-14'}
                         src={getImagePathWithTheme('card_slider_right',true)}/>
                </div>
            </Tooltip>

            <Tooltip placement="top" overlayClassName='font-size-12' title={<div className={'flex-column-center'}>
                <span>{t("Open in popup")}</span><span>{isMacOS() ? t("CmdCtrlToOpenInFloatingWindow").replace("Ctrl", "Cmd") : t("CmdCtrlToOpenInFloatingWindow")}</span>
            </div>} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{
                         pointerEvents: isEnableEvents ? 'all' : 'none',
                         display: isExpandNode() ? 'inherit' : 'none'
                     }}
                     onClick={(event: any) => {
                         let isCtrl = event.ctrlKey || event.metaKey;
                         //弹窗打开..
                         getCardById(props.data.id).then(res => {
                             if (res){
                                 window.openDialogCard({...res,isPin:isCtrl});
                             }else{
                                 window.openDialogCard({...props.data,isPin:isCtrl});
                             }
                         })
                     }}>
                    <img className={'img-14'}
                         src={getImagePathWithTheme('card_open_in_popup',true)}/>
                </div>
            </Tooltip>

            {
                isHiddenInLibrary &&
                <Tooltip placement="top" overlayClassName='font-size-12' title={t("Make visible in library")} arrow={false}>
                    <div className={'title-image-hover ml-6 cursor-pointer'}
                         style={{
                             pointerEvents: isEnableEvents ? 'all' : 'none',
                             display: isExpandNode() ? 'inherit' : 'none'
                         }}
                         onClick={async () => {
                             //侧栏打开..
                             const card:any = await getCardById(props.element.customData.generationData.id);
                             card.isHidden = 0;
                             updateCard(card);
                             props.element.customData.generationData.isHidden = 0;
                             setIsHiddenInLibrary(false);
                         }}>
                        <img className={'img-16'}
                             src={getImagePathWithTheme('card_visible_from_library')}/>
                    </div>
                </Tooltip>
            }


            {
                //标题
                <Tooltip placement="top" open={isShowDoubleTitleTip} onOpenChange={(e)=>{
                    setIsShowDoubleTitleTip(e);
                }} overlayClassName='font-size-12' arrow={false}
                         title={t("Double click to open in sidebar")}>
                    <span className={'ml-10 span-single-line title-font-family'} style={{
                        fontWeight: '700',
                        // background:'red',
                        marginRight: '21px',
                        visibility: (props.element.customData.generationData.isExpand == false) ? 'visible' : 'visible',
                        // opacity:(props.element.customData.generationData.isExpand == false) ? '1':'0',
                        flexGrow: '1',
                        textAlign: 'center',
                        color: 'var(--text-color)'
                    }} onMouseMove={(e)=>{
                        // const fOffsetX = e.nativeEvent.offsetX + e.currentTarget.offsetLeft;
                        // const fOffsetY = e.nativeEvent.offsetY;
                        // const  fCenterX = props.element.width / 2 ;
                        // if (fOffsetX < fCenterX+ 20  && fOffsetX > fCenterX - 20) {
                        //     setTimeout(()=>{
                        //         setIsShowDoubleTitleTip(false);
                        //     },100)
                        // }
                        // console.log('xxxx',e)
                    }} onMouseLeave={(e)=>{
                        setIsShowDoubleTitleTip(false);
                    }}>{(isExpand == false) ? getCardTitle({
                        name: cardTitle,//divTitleRef.current?.innerText,
                        thumbHtml: editor?.getHTML(),
                        type:'card'
                    }) : '　'}</span>
                </Tooltip>
            }

            <Tooltip placement="top" overlayClassName='font-size-12' title={t("Color")} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{flexShrink: '0', display: isExpandNode() ? 'inherit' : 'none'}} >
                    <Popover trigger={"click"} placement={"bottom"}
                             arrow={false}
                             align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                             content={
                                 props.app.actionManager.renderAction("changeCardBackgroundColorPopover")}>
                        <img className={'img-16'}
                             style={{pointerEvents: isEnableEvents ? 'all' : 'none',}}
                             src={getImagePathWithTheme('card_toolbar_color.svg',true)}/>
                    </Popover>
                </div>
            </Tooltip>
            <Tooltip placement="top" overlayClassName='font-size-12'  title={<div>
                {
                    arrayTags.length == 0 ?
                        <span>{t("Tags")}</span> :
                        arrayTags.map((item, index) => {
                            return <span>{item + ((index == arrayTags.length - 1) ? '' : ' , ')}</span>
                        })
                }
            </div>} arrow={false} onOpenChange={(e)=>{
                if (e) {
                    getCardById(props.element?.customData?.generationData?.id).then(res=>{
                        if (res){
                            setArrayTags(res.tags || [])
                        }
                    })
                }
            }}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{flexShrink: '0', display: isExpandNode() ? 'inherit' : 'none'}} onClick={() => {
                    //先保存下这个项目
                    window.saveNotes().then(res=>{
                        updateEditCard().then(res => {
                            //更新侧栏...
                            window.showManageTags([res]);
                        })
                    })
                }}>
                    <img className={'img-16'}
                         style={{pointerEvents: isEnableEvents ? 'all' : 'none',}}
                         src={getImagePathWithTheme('card_toolbar_tag.svg',true)}/>
                </div>
            </Tooltip>

            <Tooltip placement="top" overlayClassName='font-size-12' title={t("Info")} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'}
                     style={{flexShrink: '0', display: isExpandNode() ? 'inherit' : 'none'}} onClick={() => {
                         //先保存下这个项目
                    window.saveNotes().then(res=>{

                    })

                    updateEditCard().then(res => {
                        //更新侧栏...
                        window.showInfo('library', res);
                    })
                    // window.showInfo('library', res);

                }}>
                    <img className={'img-16'}
                         style={{pointerEvents: isEnableEvents ? 'all' : 'none',}}
                         src={getImagePathWithTheme('canvas_note_info',true)}/>
                </div>
            </Tooltip>



            {/*<Dropdown trigger={['click']} menu={{items: MENU_MORE}}>*/}
            {/*    <img className={'img-12 cursor-pointer ml-16'} style={{flexShrink: '0', pointerEvents: 'all',display:isExpandNode()?'inherit':'none'}}*/}
            {/*         src={getImagePathWithTheme('vertical_more')}/>*/}
            {/*</Dropdown>*/}

            <Tooltip placement="top" overlayClassName='font-size-12' title={t("More")} arrow={false}>
                <div className={'title-image-hover ml-6 cursor-pointer'} style={{
                    flexShrink: '0',
                    pointerEvents: isEnableEvents ? 'all' : 'none',
                    display: isExpandNode() ? 'inherit' : 'none'
                }} onClick={() => {
                    postMessage(EVENT_SHOW_CONTEXT_MENU, props.element)
                }}>
                    <img className={'img-14'}
                         src={getImagePathWithTheme('note_card_h_more',true)}/>
                </div>
            </Tooltip>
        </div>

        {/*style={{height: 'calc(100% - 32px)', overflowY: 'auto'}}*/}
        <div style={{height: APP_WEB ? '16px' : '0px'}}></div>

        <div ref={divContainerRef} className={'div-placeholder ' /*+ ((props.element.customData.generationData.isEditable)?'':'scrollbar-transparent')*/} id={'div-cardedit-scroll-' + props.element.id}
             onScroll={(event) => {
                 // if (!props.element?.customData?.generationData?.isEditable) {
                 //     event.preventDefault();
                 //     event.currentTarget.scrollTop = (mapDivScroll[props.element.id] || 0);
                 // }else {
                 //     mapDivScroll[props.element.id] = event.currentTarget.scrollTop;
                 // }
                 postMessage(EVENT_CLOSE_IMAGE_ACTION);
             }}
             onMouseDown={(event) => {
                 global.g_isCanvasCardMouseDown = true;
             }}
             onClick={() => {
                 onCardClick();
             }}

             style={{
                 overflowY: props.element.customData.generationData.isEditable?'auto':'hidden',
                 overflowX: props.element.customData.generationData.isEditable?'auto':'hidden',
                 padding: '0px 26px 0px 26px',
                 zIndex: '2006',
                 scrollbarColor:'transparent',
                 marginTop:'-4px',
                 scrollbarGutter:'stable'  //这个属性很重要，使滚动条提前占位！！！！！！！！！滚动条滚动条滚动条滚动条滚动条滚动条滚动条滚动条
             }}>
            {
                editor && false &&(
                    <BubbleMenu editor={editor} className={'card-eidt-bubblemenu-class'} shouldShow={()=> {
                        if (!mEditor.current)return false;
                        const {from,to} = mEditor.current.state.selection;
                        let szName = mEditor.current.state.selection.node?.type?.name;
                        if ('deeplink' == szName)return false;
                        if (to != from) {
                            return true;
                        }
                        return false;
                    }} tippyOptions={{
                        duration: 200,
                        hideOnClick: true,
                        maxWidth:'650px',
                        // offset:getBubbleMenuOffset()
                    }}>
                        <div className={style.action} style={{display: isShowTextBar ? 'grid' : 'none', width: '100%'}}>
                            <Dropdown overlayStyle={{fontSize: '12px', zIndex: MAX_Z_INDEX}} menu={{
                                items: [
                                    {
                                        label: t('Text'),
                                        key: ''
                                    }, {
                                        label: t('H1'),
                                        key: 1
                                    }, {
                                        label: t('H2'),
                                        key: 2
                                    }, {
                                        label: t('H3'),
                                        key: 3
                                    }
                                ], async onClick(event) {
                                    const e = Number(event.key)
                                    if (e) {
                                        editor.chain().focus().setHeading({level: e}).run()
                                    } else {
                                        editor.chain().focus().setParagraph().run()
                                    }
                                }
                            }}>
                                <div className='flex-row-vertical-center' style={{
                                    marginLeft: '4px',
                                    paddingLeft: '2px',
                                    width: '100%',
                                    whiteSpace: 'nowrap'
                                }}>
                                  <span className={'default-font-family'} style={{fontSize: '13px'}}>
                                    {editor.isActive('heading', {level: 1}) ? t('H1') :
                                        editor.isActive('heading', {level: 2}) ? t('H2') :
                                            editor.isActive('heading', {level: 3}) ? t('H3') : t('Text')
                                    }
                                  </span>
                                    <img className='img-28' style={{marginTop: '-1px'}}
                                         src={getImagePathWithTheme('note_tool_dropdown')}/>

                                </div>
                            </Dropdown>

                            <div className={'line-card-h-split'}></div>

                            <div
                                className={editor.isActive("bold") ? style.act : null}
                                onClick={() => {
                                    editor.chain().focus().toggleBold().run();
                                    updateEditCardHtml();
                                    props.app.pushHistory();
                                }}
                                title={t("Bold")}
                            >
                                {/*<TextBold theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_bold' + (editor.isActive("bold") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("italic") ? style.act : null}
                                onClick={() => {
                                    editor.chain().focus().toggleItalic().run();
                                    updateEditCardHtml();
                                    props.app.pushHistory();
                                }}
                                title={t("Italic")}
                            >
                                {/*<TextItalic theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_italic' + (editor.isActive("italic") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("underline") ? style.act : null}
                                onClick={() => {
                                    editor.chain().focus().toggleUnderline().run();
                                    updateEditCardHtml();
                                    props.app.pushHistory();
                                }}
                                title={t("Underline")}
                            >
                                {/*<TextUnderline theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_underline' + (editor.isActive("underline") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={editor.isActive("strike") ? style.act : null}
                                onClick={() => {
                                    editor.chain().focus().toggleStrike().run();
                                    updateEditCardHtml();
                                    props.app.pushHistory();
                                }}
                                title={t("Strokethrough")}
                            >
                                {/*<Strikethrough theme="outline" size="16" fill="#333"/>*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_strikethrough' + (editor.isActive("strike") ? '_selected' : ''))}/>
                            </div>
                            <div
                                className={
                                    editor.isActive({textAlign: "center"}) ? style.act : null
                                }
                                onClick={() => {
                                    editor.isActive({textAlign: "center"})
                                        ? editor.chain().focus().setTextAlign("left").run()
                                        : editor.chain().focus().setTextAlign("center").run()
                                    updateEditCardHtml();
                                    props.app.pushHistory();
                                }}
                                title={t("Align")}
                            >
                                {/*<AlignTextCenter theme="outline" size="16" fill="#333" />*/}
                                <img className='img-28'
                                     src={getImagePathWithTheme('note_tool_align' + (editor.isActive({textAlign: "center"}) ? '_selected' : ''))}/>
                            </div>

                            <div className={'line-card-h-split'}></div>
                            <div style={{margin: '0 8px 0 14px', display: 'flex'}}>
                                <ColorPickers editor={editor}/>
                            </div>
                            <div className={'line-card-h-split'}></div>

                            <div
                                className={
                                    editor.getAttributes('link').href ? style.act : null
                                }
                                onClick={() => {
                                    showLink();
                                }}>
                                {/*<LinkIcon theme="outline" size="16" fill="#333" />*/}
                                <img className='img-20'
                                     src={getImagePathWithTheme('card_bubble_menu_link' + (editor.getAttributes('link').href ? '_selected' : ''))}/>
                            </div>

                            <div className={'line-card-h-split'}></div>
                            <div style={{
                                margin: '0 6px 0 0',
                                display: 'flex',
                                width: '100%',
                                cursor: 'pointer',
                                paddingRight: '0px'
                            }}>
                                <TurnNewCard editor={editor}/>
                            </div>

                            <div className={'line-card-h-split'}></div>
                            <div style={{margin: '0 4px', display: 'flex', width: '100%', cursor: 'pointer'}}>
                                <HighlightPicker editor={editor} data={props.data}/>
                            </div>

                        </div>
                    </BubbleMenu>
                )}
            {
                props.element.customData.generationData.libraryType == 'journal' &&
                <span className={'font-family-regular'}
                      style={{
                          marginBottom: '6px',
                          display: 'block',
                          color: 'var(--primary-color)'
                      }}>{t(MAP_WEEK_FULL[`${(new Date(props.element.customData.generationData.journalTime)).getDay()}`])}</span>
            }

            {/*<div ref={divTitleRef} id={props.element.id} className={'title-font-family'} data-isedit={'true'}*/}
            {/*     data-text={t("Untitled")}*/}
            {/*     suppressContentEditableWarning={true} contentEditable={isEditable}*/}
            {/*     style={{*/}
            {/*         fontSize: '26px',*/}
            {/*         fontWeight: '700',*/}
            {/*         color: 'var(--text-color)',*/}
            {/*         textWrap: 'wrap',*/}
            {/*         wordWrap: 'break-word',*/}
            {/*         whiteSpace: 'pre-wrap',*/}
            {/*         marginTop: `0px`,*/}
            {/*         display:'none'*/}
            {/*     }}*/}
            {/*     onKeyDown={(event) => {*/}
            {/*         if (event.key == KEYS.ENTER) {*/}
            {/*             event.preventDefault();*/}
            {/*             event.stopPropagation();*/}
            {/*             props.element.customData.generationData.isEditable = true;*/}
            {/*             editor?.setEditable(true);*/}
            {/*             editor?.commands.focus(0);*/}
            {/*         } else {*/}
            {/*             setTimeout(() => {*/}
            {/*                 //这里也要调整整个高度..*/}
            {/*                 //更新侧栏...*/}
            {/*                 const doc = imgServer.parserImgFromHtml(editor?.getHTML() as string);*/}
            {/*                 const name = mTitle;//divTitleRef.current?.innerText;*/}
            {/*                 const card = {*/}
            {/*                     ...props.data,*/}
            {/*                     type: 'card',*/}
            {/*                     doc: doc,*/}
            {/*                     name: name*/}
            {/*                 }*/}
            {/*                 postMessage(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD, card);*/}

            {/*                 var range = document.createRange();*/}
            {/*                 range.selectNodeContents(divTitleRef.current);*/}
            {/*                 range.collapse(false);*/}
            {/*                 var sel = window.getSelection();*/}
            {/*                 sel.removeAllRanges(range);*/}
            {/*                 sel.addRange(range);*/}

            {/*                setTimeout(()=>{*/}
            {/*                    updateElementHeight();*/}
            {/*                },2000)*/}


            {/*             }, 10)*/}
            {/*         }*/}
            {/*     }}*/}
            {/*     onBlur={() => {*/}
            {/*        global.g_isDrawCardEditing = false;*/}
            {/*        global.g_currentCardEditElement = null;*/}
            {/*        global.g_currentCardEditor = null;*/}
            {/*        updateEditCard();*/}
            {/*}}>*/}
            {/*    {cardTitle}*/}
            {/*</div>*/}

            <textarea id={props.element.id} disabled={props.element?.customData?.generationData?.libraryType == 'journal'} className={'font-family-0'} ref={txtTitleRef} placeholder={t("Untitled")} style={{
                fontSize: '24px',
                fontWeight: '700',
                color: 'var(--text-color)',
                textWrap: 'wrap',
                width:'100%',
                wordWrap: 'break-word',
                whiteSpace: 'pre-wrap',
                marginTop: `8px`,
                padding:'0px 0px',
                overflow:'hidden',
                height:'32px',
                display:(hasTitle && (cardTitle || props.element.customData.generationData.isEditable))?'inherit':'none',
                resize:'none',
                background:'transparent',
                outline:'none',border:'none'
            }} onInput={(event)=>{
                postMessage(EVENT_RENAME_LIBRARY_ITEM,{id:props.element.customData.generationData.id,name:event.target.value})
            }} onChange={(event)=>{
                setCardTitle(event.currentTarget.value);
                window.globalRefreshList('refresh_canvas_deeplink_card_title_',{id:props.element.customData.generationData.id,name:event.currentTarget.value})
            }} onKeyDown={(event)=>{
                if (event.key == KEYS.ENTER) {
                    event.preventDefault();
                    event.stopPropagation();
                    props.element.customData.generationData.isEditable = true;
                    editor?.setEditable(true);
                    editor?.commands.focus(0);
                }else if (event.key == KEYS.BACKSPACE) {
                    if (event.currentTarget.value == '') {
                        //移除标题
                        setHasTitle(false);
                        props.element.customData.generationData.hasTitle = false;
                        props.data.hasTitle = false;
                        editor?.commands.focus(0);
                    }
                }
            }} onKeyUp={(event) => {
                if (event.key == KEYS.ENTER) {
                    event.preventDefault();
                    event.stopPropagation();
                    props.element.customData.generationData.isEditable = true;
                    editor?.setEditable(true);
                    editor?.commands.focus(0);
                } else {
                    updateTextAreaHeight();
                    updateElementHeight();

                    setTimeout(() => {
                        //这里也要调整整个高度..
                        //更新侧栏...
                        const doc = imgServer.parserImgFromHtml(editor?.getHTML() as string,props.element.id);
                        const name = event.target?.value;
                        const card = {
                            ...props.data,
                            type: 'card',
                            doc: doc,
                            name: name
                        }
                        postMessage(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD, card);
                    }, 300)
                }
            }} onBlur={(editor) => {
                global.g_isDrawCardEditing = false;
                global.g_currentCardEditElement = null;
                global.g_currentCardEditor = null;
                updateEditCard();

                updateEditCardHtml();
                props.app.pushHistory();
            }} onFocus={(event)=>{
                if (props.element.locked) {
                    txtTitleRef.current?.blur();
                }
                //删除这个属性
                delete global.g_mapCardPos[props.data.id];
            }}
                      value={cardTitle}>
            </textarea>

            <EditorContent id={'editcontent-' + props.data.id} className="tableStyle"
                           style={{
                               padding: '0px',
                               textAlign: 'left',
                               marginBottom: '20px',
                               marginLeft: '-2px',
                               fontSize:'15px',
                               marginTop: hasTitle?'10px':'10px',
                           }} editor={editor}/>

            <ImgAction editor={editor}/>
        </div>

        {/*<div style={{position:'absolute',left:'0',top:'0',width:'100%',height:'100%', border:'4px solid red',borderRadius:'8px',pointerEvents:'none'}}/>*/}

    </div>
})

export default React.memo(CardEdit,areEqual);

function areEqual(prevProps: any, nextProps: any){
    if (JSON.stringify(prevProps.element) == JSON.stringify(nextProps.element) && prevProps.isSelected == nextProps.isSelected){
        return true;
    }
    return false
}


















